module.exports = __webpack_public_path__ + "img/mono_7.903cbb69.png";